(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noceve-brand"]) return;
  try {
    
(function(){document.addEventListener('noceve:added',function(){var btn=document.querySelector('[data-vp-atc]');if(!btn)return;var label=btn.querySelector('[data-vp-atc-txt]');if(!label)return;var initial=btn.dataset.label||label.textContent;label.textContent='Ajouté';btn.classList.add('is-done');setTimeout(function(){label.textContent=initial;btn.classList.remove('is-done');},1600);});})();

// Tiroir panier : la ligne article restait invisible apres un ajout.
//
// Dawn pose `is-empty` sur <cart-drawer> quand le panier est vide au chargement,
// puis remplace l'innerHTML du tiroir a chaque ajout — sans jamais retirer la
// classe de l'element lui-meme. Or base.css contient
// `.is-empty .cart__contents{display:none}` : le <form> qui porte l'article
// restait masque. Resultat vu en test : le tiroir s'ouvrait, le sous-total
// affichait bien 149,90 EUR, mais ni l'image, ni le nom, ni la quantite.
// C'est le parcours normal d'un client qui ajoute son premier article.
//
// On resynchronise la classe sur l'etat reel du DOM : y a-t-il une .cart-item ?
// L'observation porte sur childList uniquement — un toggle de classe ne
// declenche pas de mutation childList, donc pas de boucle.
(function () {
  var drawers = document.querySelectorAll('cart-drawer');
  if (!drawers.length) return;
  var sync = function (d) { d.classList.toggle('is-empty', !d.querySelector('.cart-item')); };
  drawers.forEach(function (d) {
    sync(d);
    new MutationObserver(function () { sync(d); }).observe(d, { childList: true, subtree: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noceve-collection"]) return;
  try {
    
(function () {
  var root = document.querySelector('.vcol-wrap');
  if (!root) return;

  // --- Accordeons de filtres ---
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-vcol-filter-toggle]');
    if (!t) return;
    var f = t.closest('[data-vcol-filter]');
    var open = f.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // --- Vue grille / liste ---
  var grid = root.querySelector('[data-vcol-grid]');

  function applyDensity(v) {
    if (!grid) return;
    if (v === 'list') {
      grid.setAttribute('data-view', 'list');
    } else {
      grid.setAttribute('data-view', 'grid');
      grid.style.setProperty('--vcol-cols', v);
    }
    root.querySelectorAll('[data-vcol-cols]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-vcol-cols') === v ? 'true' : 'false');
    });
  }

  root.querySelectorAll('[data-vcol-cols]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = btn.getAttribute('data-vcol-cols');
      applyDensity(v);
      try { localStorage.setItem('vcolCols', v); } catch (err) {}
    });
  });

  try {
    var saved = localStorage.getItem('vcolCols');
    if (saved && root.querySelector('[data-vcol-cols="' + saved + '"]')) applyDensity(saved);
  } catch (err) {}

  // --- Soumission automatique (cases a cocher + tri) ---
  var form = root.querySelector('[data-vcol-form]');
  function submitForm() { if (form) form.submit(); }
  root.querySelectorAll('[data-vcol-auto]').forEach(function (i) {
    i.addEventListener('change', submitForm);
  });
  var sort = document.getElementById('vcol-sort');
  if (sort) sort.addEventListener('change', submitForm);

  // --- Curseur de prix a deux poignees ---
  root.querySelectorAll('[data-vt-price]').forEach(function (w) {
    var lo = w.querySelector('[data-vt-lo]'),
        hi = w.querySelector('[data-vt-hi]'),
        nlo = w.querySelector('[data-vt-num-lo]'),
        nhi = w.querySelector('[data-vt-num-hi]'),
        fill = w.querySelector('[data-vt-fill]'),
        max = parseFloat(w.getAttribute('data-max')) || 100;
    if (!lo || !hi) return;
    function paint() {
      var a = Math.min(+lo.value, +hi.value), b = Math.max(+lo.value, +hi.value);
      if (fill) {
        fill.style.left = (a / max * 100) + '%';
        fill.style.width = ((b - a) / max * 100) + '%';
      }
    }
    function fromSliders() {
      if (+lo.value > +hi.value) { var t = lo.value; lo.value = hi.value; hi.value = t; }
      if (nlo) nlo.value = lo.value;
      if (nhi) nhi.value = hi.value;
      paint();
    }
    lo.addEventListener('input', fromSliders);
    hi.addEventListener('input', fromSliders);
    if (nlo) nlo.addEventListener('input', function () { lo.value = nlo.value || 0; paint(); });
    if (nhi) nhi.addEventListener('input', function () { hi.value = nhi.value || max; paint(); });
    paint();
  });

  // --- Tiroir de filtres mobile : on deplace la vraie sidebar, pas une copie ---
  var drawer = document.querySelector('[data-vcol-drawer]'),
      dbody = document.querySelector('[data-vcol-drawer-body]'),
      overlay = document.querySelector('[data-vcol-overlay]'),
      sidebar = root.querySelector('[data-vcol-sidebar]'),
      home = sidebar ? sidebar.parentNode : null,
      moved = false;

  function isMobile() { return window.matchMedia('(max-width:989px)').matches; }

  function openDrawer() {
    if (!drawer || !sidebar || !dbody) return;
    dbody.appendChild(sidebar);
    sidebar.style.display = 'block';
    sidebar.style.position = 'static';
    moved = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    var c = drawer.querySelector('[data-vcol-close-drawer]');
    if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
    if (moved && sidebar && home) {
      home.appendChild(sidebar);
      sidebar.style.display = '';
      sidebar.style.position = '';
      moved = false;
    }
    var o = root.querySelector('[data-vcol-open-drawer]');
    if (o) o.focus();
  }

  var openBtn = root.querySelector('[data-vcol-open-drawer]');
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  var closeBtn = document.querySelector('[data-vcol-close-drawer]');
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });
  window.addEventListener('resize', function () {
    if (!isMobile() && moved) closeDrawer();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noceve-compat-test"] && !Shopify.designMode) return;
  try {
    (function(){document.addEventListener('submit',function(e){var f=e.target;if(!f.classList||!f.classList.contains('vtc__form'))return;e.preventDefault();var res=document.getElementById(f.dataset.res);if(!res)return;var d=new FormData(f),q1=d.get('q1'),q2=d.get('q2'),q3=d.get('q3'),blockers=[],checks=[];if(q1==='ko')blockers.push('Une prise secteur à portée est nécessaire : Nocève Lucéa reste branché pendant son utilisation.');if(q1==='idk')checks.push('Vérifiez la distance entre votre fenêtre et la prise la plus proche, ainsi que la longueur indiquée dans la notice du modèle.');if(q2==='ko')blockers.push('La corde de sécurité doit pouvoir être fixée à un point d’ancrage stable et suffisamment résistant.');if(q2==='idk')checks.push('Identifiez un point d’ancrage stable et suffisamment résistant avant l’utilisation.');if(q3==='petite')checks.push('Pour de petits carreaux, des croisillons ou une configuration atypique, contactez-nous avec une photo avant de commander.');var h,p,list='';if(blockers.length){h='Une adaptation est nécessaire';p='Au moins une condition de base n’est pas réunie :';list=blockers.concat(checks).map(function(x){return '<li>'+x+'</li>';}).join('');}else if(checks.length){h='Les conditions de base semblent réunies';p='Il reste simplement à vérifier :';list=checks.map(function(x){return '<li>'+x+'</li>';}).join('');}else{h='Les conditions de base sont réunies';p=q3==='grande'?'Votre configuration correspond au type de grandes surfaces vitrées pour lesquelles Lucéa apporte le plus de confort.':'Prise à portée et point d’ancrage disponible : les principales conditions matérielles sont réunies.';}res.innerHTML='<h3>'+h+'</h3><p>'+p+'</p>'+(list?'<ul>'+list+'</ul>':'')+'<p><a href="/pages/contact">Un doute ? Envoyez-nous une photo de votre fenêtre</a></p><p>Ce test vérifie les conditions de base et ne remplace pas les consignes de la notice.</p>';res.hidden=false;});})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noceve-contact"] && !Shopify.designMode) return;
  try {
    
/* Etat de chargement pendant la soumission native, et focus sur le message
   de retour apres rechargement : le lecteur d'ecran l'annonce immediatement. */
(function () {
  var form = document.querySelector('.nct-form');
  if (form) {
    form.addEventListener('submit', function () {
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
      var btn = form.querySelector('[data-nct-submit]');
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    });
  }
  var status = document.getElementById('nct-status');
  if (status) {
    try { status.focus({ preventScroll: true }); } catch (e) { status.focus(); }
    status.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noceve-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-noc-sticky]');
  var sentinel = document.getElementById('noc-sticky-sentinel');
  if (!bar || !sentinel || !('IntersectionObserver' in window)) return;
  bar.hidden = false;
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        bar.removeAttribute('data-visible');
      } else {
        bar.setAttribute('data-visible', '');
      }
    });
  }, { rootMargin: '-320px 0px 0px 0px' }).observe(sentinel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noceve-vfaq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vfaq-q]');
    if (!btn) return;
    var item = btn.closest('[data-vfaq-item]');
    var panel = item.querySelector('[data-vfaq-a]');
    var open = !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
  });
  // Une reponse ouverte doit suivre le redimensionnement de la fenetre.
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () {
      document.querySelectorAll('[data-vfaq-item].is-open [data-vfaq-a]').forEach(function (p) {
        p.style.maxHeight = p.scrollHeight + 'px';
      });
    }, 150);
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();
})();
